/**
 * Customized font weights.
 *
 * Reference: https://chakra-ui.com/docs/theming/theme
 */

const fontWeights = {
  thin: '100',
  xlight: '200',
  light: '300',
  normal: '400',
  medium: '500',
  semibold: '600',
  bold: '600'
};

export default fontWeights;
